import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps } from '@frontend/design-system';

type Props = ModalControlModalProps & {
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
};

export const ScheduleAvailabilityUnsavedChangesConfirmation = ({
  onSave,
  onCancel,
  onDiscard,
  ...modalProps
}: Props) => {
  const { t } = useTranslation('schedule');
  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Unsaved Changes')}
      message={t('You have unsaved changes to these appointment hours. If you leave now, these changes will be lost')}
      confirmLabel={t('Save')}
      cancelLabel={t('Cancel')}
      backLabel={t('Discard')}
      backDestructive
      onConfirm={onSave}
      onCancel={onCancel}
      onBackClick={onDiscard}
    />
  );
};
